import React, { useMemo } from "react";
import { Button, Checkbox, Space, Tree } from "antd";
import { MI_USER_LAW, allLawFlags } from "./spr-sotr-laws-data";

/**
 * Вкладка «Права» — дерево чекбоксов как Delphi VSTLaws.
 */
const SprSotrLaws = ({ flags, onChange, disabled = false }) => {
  const liveTree = useMemo(
    () =>
      MI_USER_LAW.filter((x) => x.isGroup).map((group) => ({
        key: `group-${group.id}`,
        groupId: group.id,
        children: MI_USER_LAW.filter((x) => !x.isGroup && x.idUpper === group.id).map((leaf) => ({
          key: `law-${leaf.id}`,
          lawId: leaf.id,
          isLeaf: true
        }))
      })),
    []
  );

  const setLeaf = (lawId, checked) => {
    const next = [...(flags || allLawFlags(true))];
    next[lawId] = checked;
    onChange?.(next);
  };

  const setGroup = (groupId, checked) => {
    const next = [...(flags || allLawFlags(true))];
    MI_USER_LAW.filter((x) => !x.isGroup && x.idUpper === groupId).forEach((leaf) => {
      next[leaf.id] = checked;
    });
    onChange?.(next);
  };

  const onCheckAll = () => onChange?.(allLawFlags(true));
  const onClearAll = () => onChange?.(allLawFlags(false));

  const titleRender = (node) => {
    if (node.lawId != null) {
      const item = MI_USER_LAW.find((x) => x.id === node.lawId);
      return (
        <Checkbox
          checked={flags[node.lawId] !== false}
          disabled={disabled}
          onChange={(e) => setLeaf(node.lawId, e.target.checked)}
        >
          {item?.name}
        </Checkbox>
      );
    }
    if (node.groupId != null) {
      const children = MI_USER_LAW.filter((x) => !x.isGroup && x.idUpper === node.groupId);
      const checkedCount = children.filter((c) => flags[c.id] !== false).length;
      const allChecked = children.length > 0 && checkedCount === children.length;
      const noneChecked = checkedCount === 0;
      const group = MI_USER_LAW.find((x) => x.id === node.groupId);
      return (
        <Checkbox
          checked={allChecked}
          indeterminate={!allChecked && !noneChecked}
          disabled={disabled}
          onChange={(e) => setGroup(node.groupId, e.target.checked)}
        >
          <strong>{group?.name}</strong>
        </Checkbox>
      );
    }
    return null;
  };

  return (
    <div className="spr-sotr-card__tab">
      <div className="spr-sotr-card__laws-toolbar">
        <Space>
          <Button size="small" onClick={onCheckAll} disabled={disabled}>
            Полные
          </Button>
          <Button size="small" onClick={onClearAll} disabled={disabled}>
            Убрать все
          </Button>
        </Space>
      </div>
      <div className="spr-sotr-card__body">
        <Tree
          className="spr-sotr-laws__tree"
          defaultExpandAll
          selectable={false}
          treeData={liveTree}
          titleRender={titleRender}
        />
      </div>
    </div>
  );
};

export default SprSotrLaws;
